import { computed, ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { Screen } from 'quasar';

export const SIDEBAR_WIDTH = 210;
// Over the page, below a laptop.
export const SIDEBAR_OVERLAY_WIDTH = 256;
export const SIDEBAR_MINI_WIDTH = 77;

export const useStylesStore = defineStore('styles', () => {
  // Full drawer or icon rail; reset when the window crosses 1024.
  const drawerOpened = ref<boolean>(Screen.gt.sm);
  watch(
    () => Screen.gt.sm,
    (isLaptopUp) => {
      drawerOpened.value = isLaptopUp;
    },
  );
  // QDrawer's v-model. Only phones set it; from 600 up show-if-above keeps it true.
  const drawerShowing = ref(false);
  // Width the page gives up: none on a phone, the rail on a tablet (the drawer overlays it).
  const drawerWidth = computed(() => {
    if (Screen.lt.sm) return 0;
    if (Screen.lt.md || !drawerOpened.value) return SIDEBAR_MINI_WIDTH;
    return SIDEBAR_WIDTH;
  });

  const toggleDrawer = (value: boolean) => {
    drawerOpened.value = value;
  };
  const showDrawer = (value: boolean) => {
    drawerShowing.value = value;
  };
  return { toggleDrawer, showDrawer, drawerOpened, drawerShowing, drawerWidth };
});
